import React, { Component } from 'react';
import _ from "lodash";
import { connect } from 'react-redux';
import OnBoardingCCMDataTable from './OnBoardingCCMDataTable';
import moment from "moment";
import {
  Col,
  Label,
  Row,
  FormGroup,
  Input
} from "reactstrap";
import { pasteValue } from '../Reusable/OnPasteValue';
import getDeviceType from "../../helpers/getDeviceTypeHelper";
import {deviceType} from "../../constants/general.constant";
class OnBoardingCCMList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      search: "",
      enrolledPrograms: "",
      displayActiveList: true,
      displayDemoList: null,
      displayCellularConnectivityList: false,
      fileLoading: false,
      startDate: "",
      endDate: "",
      endDateError: null,
      link: undefined,
      shippedStatus: undefined,
      device: undefined,
      deviceModel: undefined
    };
    this.timeout =  null;
    this.onNavigatePage = this.onNavigatePage.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.filterShippedStatus = this.filterShippedStatus.bind(this);
    this.fetchDataFromServer = this.fetchDataFromServer.bind(this);
    this.handleInputDateChange = this.handleInputDateChange.bind(this);
    this.handleDeviceChange = this.handleDeviceChange.bind(this);
  }

  onNavigatePage(page, limit) {
    //console.log("page : " + page)
  }
  handleDeviceChange(event) {
    const target = event.target;
    var value = target.type === "checkbox" ? target.checked : target.value;    
    this.setState({
      device: value && value != "-1" ? value : undefined,
    }, () => {
      this.fetchData();
    });  
  }
  handleTableChange(type, { page, sizePerPage, filters, sortField, sortOrder }) {
    var sortNewOrder;
    if(this.state.sortOrder == "desc"){
      sortNewOrder = "asc"
      this.setState({
        page: page, limit: sizePerPage, sortField: sortField, sortOrder: sortNewOrder
      }, () => {
        this.fetchData();
      });
    }else if(this.state.sortOrder == undefined && sortField == "lastNoteCreatedDate"){
      sortNewOrder = "desc"
      this.setState({
        page: page, limit: sizePerPage, sortField: sortField, sortOrder: sortNewOrder
      }, () => {
        this.fetchData();
      });
    }else{
      sortNewOrder = "desc"
      this.setState({
        page: page, limit: sizePerPage, sortField: sortField, sortOrder: sortNewOrder
      }, () => {
        this.fetchData();
      });
    }
  }
  filterShippedStatus(event) {
    if (event.target.value) {
      this.setState({
        page: 1,
        sortField: "",
        sortOrder: "",
        shippedStatus: event.target.value
      }, () => {
        this.fetchData();
      });
    } else {
      this.setState({
        shippedStatus: undefined
      }, () => {
        this.fetchData();
      });
    }
  }
  componentDidMount() {
    this.props.fetchDataFromServer(this.fetchDataFromServer);
  }
  fetchDataFromServer() {
    this.setState({
      page: 1,
      limit: 10,
      search: "",
      shippedStatus: "",
      endDateError: null,
      device: "",
      startDate:"",
      endDate:"",
      sortField: "",
      sortOrder: "",
      deviceModel: ""
    }, () => {
      this.fetchData();
    });
  }
  fetchData() {
    this.props.dispatch({
      type: "DO_GET_ALL_ON_BOARDING_CCM_DATA",
      payload: {
        page: this.state.page,
        limit: this.state.limit,
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        sortField: this.state.sortField ? this.state.sortField : "",
        sortOrder: this.state.sortOrder ? this.state.sortOrder : "",
        search: this.state.search ? this.state.search : "",        
        catagoryID: this.props.catagoryID,
        shippedStatus: this.state.shippedStatus ? this.state.shippedStatus : undefined,
        onBoarding : true
      }
    });
  }
  MyExportCSV = (props) => {
    const handleClick = () => {
      this.props.dispatch({
        type: "DO_REMOVE_PATIENT_LINK_PATH",
        payload: undefined
      });
      var tz = moment.tz.guess();
      this.props.dispatch({
        type: "DO_EXPORT_ONBOARDING_CCM_LIST",
        payload: {
          tz:tz,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          catagoryID: this.props.catagoryID
        }
      });
    };
    return (
      <Row>
        <Col>
          <button 
          style={{ marginTop: 5,width:164, height:43 }} 
          className="btn btn-info ml-2 download-click-cls"
          onClick={handleClick}>
            <i class="mdi mdi-download" style={{
                fontSize: 20
              }}></i> Export to CSV
          </button>
        </Col>
      </Row>
    );
  };
  MySearch = () => {
    let input;
    const handleChange = (e) => {
      e.preventDefault();
      const val = e.target.value.replace(/[^\w\s]/gi, "")
      this.setState({
        page: 1,
          search: val,
          sortField: "",
          sortOrder: "",
      });
    };
    React.useEffect(() => {
      const timeout = setTimeout(() => {
        this.fetchData();        
      }, 200)
      // if this effect run again, because `value` changed, we remove the previous timeout
      return () => clearTimeout(timeout)
    }, [this.state.search])
    return (
      <div>
        <div class="form-group">
          <input
            type="text"
            class="form-control input-date-filter remove-bottom-margin"
            id="exampleInputName1Test"
            style={{ fontSize: "20px" }}
            placeholder="Search Last Name, First Name, Nickname, Organization, Enrolled Programs"
            ref={(n) => (input = n)}
            value={this.state.search}
            onChange={handleChange}
            onPaste={(e) => {
              e.preventDefault();
              const event = pasteValue(e);
              this.setState({ search: event.target.value });
              handleChange(event);
            }}
          />
        </div>
      </div>
    );
  };
  /**
   * Questionnaire date inputs
   * @param {*} event 
   */
  handleInputDateChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState(
      { [name]: value }, () => {
        this.isEndDateValid(this.state.endDate)
        this.fetchData()
      }
    );
  }
  isEndDateValid(value) {
    if (value === undefined || value === null || value.trim().length == 0) {
      return false;
    } else {
      var date = moment(new Date(this.state.startDate), 'MM/DD/YYYY');
      date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
      var dateEntered = new Date(value);
      var today = moment(date, 'MM/DD/YYYY');
      var enteredDate = moment(dateEntered, 'MM/DD/YYYY');
      var dDiff = today.isSameOrAfter(enteredDate);
      if (dDiff) {
        this.setState({
          endDateError: "Please select end date is greater than equal to start date."
        });
        return false;
      } else if (today.isSame(enteredDate)) {
        this.setState({
          endDateError: null
        });
        return true;
      } else {
        this.setState({
          endDateError: null
        });
        return true;
      }
    }
  };
  render() {
    if (this.props.patientFilePath) {
      if (this.state.link === undefined) {
        this.setState({
          link: this.props.patientFilePath,
        }, () => {
          this.props.dispatch({
            type: "DO_REMOVE_PATIENT_LINK_PATH",
            payload: undefined
          });
          window.open(this.state.link, "_self");
        }
        );
      }

    } else {
      this.state.link = undefined;
    }
    const device = getDeviceType();
    return (
      <>
      <Row className={`col-md-12 mx-auto float-right`} style={{paddingLeft : '0px', paddingRight : '0px'}}>
        <Col xs={12} sm={6} md={4} className="mb-3">
          <FormGroup className="remove-bottom-margin form-group-patient">
            <Label for="exampleEmail">Filter by Start Date</Label>
            <Input
              className="input-date-filter remove-bottom-margin"
              type="date"
              name="startDate"
              max={moment().format("YYYY-MM-DD")}
              onChange={this.handleInputDateChange}
              value={this.state.startDate}
            />
          </FormGroup>
        </Col>
        <Col xs={12} sm={6} md={4} className="mb-3">
          <FormGroup className="remove-bottom-margin form-group-patient">
            <Label for="examplePassword">Filter by End Date</Label>
            <Input
              className="input-date-filter remove-bottom-margin"
              type="date"
              name="endDate"
              max={moment().format("YYYY-MM-DD")}
              onChange={this.handleInputDateChange}
              value={this.state.endDate}
            />
            <Label
              style={{
                color: "red",
                textAlign: "left",
                padding: 5
              }}>{this.state.endDateError}</Label>
          </FormGroup>
        </Col>
        <Col xs={12} sm={12} md={4}>
          <FormGroup className="remove-bottom-margin form-group-patient">
            <Label for="examplePassword">&nbsp;&nbsp;</Label>
            {(this.state.startDate || this.state.endDate || this.state.search || this.state.shippedStatus || this.state.device) && (
              <button
                style={{ float: 'left', marginTop: 20, width: 150, height: 37 }}
                onClick={() => {
                  this.fetchDataFromServer()
                }}
                className="btn btn-info ml-2 close-click-cls"
              >
                <i class="mdi mdi-close" style={{
                  fontSize: 20
                }}></i>
                Clear Filters
              </button>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row className={`text-center col-md-12 mx-auto float-right`} style={{paddingLeft : '0px', paddingRight : '0px'}}>
        <Col md={device === deviceType.tablet ? 8 : 9} style={{ marginTop: 15 }}>
          <this.MySearch />
        </Col>
        <Col md={2} style={{ marginTop: 10 }}>
          <this.MyExportCSV>
            Export CSV
          </this.MyExportCSV>
        </Col>
      </Row>
      {this.props.ongoingRequest && (
        <OnBoardingCCMDataTable
          data={[]}
          page={this.state.page}
          loading={this.props.ongoingRequest}
          sizePerPage={this.state.limit}
          profileOwner={this.props.profileOwner}
          readingSubTypes={this.props.readingSubTypes}
          userId={this.props.userId}
          totalSize={0}
          onNavigatePage={this.onNavigatePage}
          onTableChange={this.handleTableChange}              
        />
      )}
      {!this.props.ongoingRequest && this.props.allOnBoradingCCMAccess && (
        <OnBoardingCCMDataTable
          data={this.props.allOnBoradingCCMAccess}
          allCategorys={this.props.allCategorys}
          page={this.state.page}
          loading={this.props.ongoingRequest}
          sizePerPage={this.state.limit}
          profileOwner={this.props.profileOwner}
          readingSubTypes={this.props.readingSubTypes}
          userId={this.props.userId}
          totalSize={this.props.totalRecode}
          onNavigatePage={this.onNavigatePage}
          onTableChange={this.handleTableChange}              
        />
      )}
      </>
    );
  }
}

// function mapStateToProps(state, ownProps) {
//   return {
//     products: state.products
//   };
// }

const mapStateToProps = ({ careprovider, user, auth }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    allOnBoradingCCMAccess,
    allCategorys,
    allBoardingDevice,
    totalRecode,
    ongoingRequest,
    patientFilePath
  } = careprovider;
  const { readingSubTypes } = auth;
  const userId = user.userDetails._id;
  const profileOwner = user.profileOwner;
  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    totalRecode,
    allOnBoradingCCMAccess,
    allCategorys,
    allBoardingDevice,
    readingSubTypes,
    userId,
    ongoingRequest,
    profileOwner,
    patientFilePath
  };
};

export default connect(mapStateToProps)(OnBoardingCCMList);
